import { render, staticRenderFns } from "./MercadopagoBrick.vue?vue&type=template&id=ae625bda&"
import script from "./MercadopagoBrick.vue?vue&type=script&lang=js&"
export * from "./MercadopagoBrick.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports